import React, { CSSProperties, ReactElement } from "react";
import { ImageInfo, ImageSrc } from "./ImageInfo";
import { ProjectInfo } from "./ProjectInfo";

export enum EditorModalType {
  positionsEditor = "positionsEditor",
  clickableAreasEditor = "clickableAreasEditor",
  clipPathEditor = "clipPathEditor",
  filterEditor = "filterEditor",
}

interface ComponentEditorContextProps {
  allImages: any[];
  projectName: string;
  projectInfo?: ProjectInfo;
  getImageSrc: (imageInfo: ImageSrc) => string | undefined;
  getVisual: (
    imageInfo: ImageInfo | undefined,
    setRef: (instance: HTMLElement | null) => void,
    style: CSSProperties,
    innerStyle?: CSSProperties,
    className?: string,
    onClick?: (event: React.MouseEvent<HTMLElement>) => void,
  ) => ReactElement | undefined;
}

export const ComponentEditorContext = React.createContext<ComponentEditorContextProps>({
  allImages: [],
  getVisual: (imageName: ImageInfo | undefined) => {
    return undefined;
  },
  projectName: "",
  getImageSrc: (imageInfo: ImageSrc) => "",
  projectInfo: undefined,
});

export const useComponentEditorContext = () => React.useContext(ComponentEditorContext);
